import React from 'react';

import get from 'lodash/get';

// eslint-disable-next-line max-len
const URL_REGEX =
  // eslint-disable-next-line max-len
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s<]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s<]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s<]{2,}|www\.[a-zA-Z0-9]+\.[^\s<]{2,})/gm;

export default {
  strategy(block, callback) {
    const text = block.getText();
    const matches = [...matchAll(text, URL_REGEX)];

    matches.forEach((match) => {
      callback(match.index, match.index + match[0].length);
    });
  },

  component({ children }: any) {
    let href = get(children, '[0].props.text', '');
    href = href.startsWith('http') ? href : 'http://' + href;
    return (
      <a target='_blank' rel='noopener noreferrer' href={href}>
        {children}
      </a>
    );
  },

  addClickableLinks(text) {
    return text.replace(URL_REGEX, function (value) {
      const href = value.startsWith('http') ? value : 'http://' + value;
      return (
        '<a tabIndex="-1" href="' + href + '" target="_blank">' + value + '</a>'
      );
    });
  },
};

function ensureFlag(flags, flag) {
  return flags.includes(flag) ? flags : flags + flag;
}

function* matchAll(str, regex) {
  const localCopy = new RegExp(regex, ensureFlag(regex.flags, 'g'));
  let match;
  // eslint-disable-next-line no-cond-assign
  while ((match = localCopy.exec(str))) {
    yield match;
  }
}
